import Flag from "react-world-flags";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { Country } from "../../../../types/types";

import CountriesMap from "./CountriesMap";
import CountriesCareerLoader from "./CountriesCareerLoader";
import { styles } from "./styles";

const CountriesCareer = ({ countries = [], isLoading }: { countries?: Country[]; isLoading?: boolean }) => {
  const { t } = useTranslation("profiles", { keyPrefix: "overview" });

  if (isLoading) {
    return <CountriesCareerLoader />;
  }

  return (
    <Box sx={styles.container}>
      <Typography sx={styles.title}>{t("countriesCareer")}</Typography>
      <Box sx={styles.contentWrapper}>
        <CountriesMap countries={countries} />
        <Box sx={styles.countriesList}>
          {countries?.map(({ country, countryCode }) => (
            <Box key={country} sx={styles.countryItem}>
              <Flag code={countryCode} style={styles.flag} />
              <Typography variant="body2" sx={styles.countryName}>
                {country}
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default CountriesCareer;
